module.exports = __webpack_public_path__ + "img/dy-icon.29453d60.png";